// @docs https://[domain]/api/v1/docs
export default {
  Apps: "/applications",
  Detail: "/applications",
  Update: "/applications",
  Create: "/applications",
  ListShort: "/applications/short",
};
